import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import './style.scss';
import Text from '../Text';

const CookieBanner = () => {
  const { t } = useTranslation();

  const titleText = t('cookie_consent_title') ;
  const descriptionText =
    t('cookie_consent_description');
  const acceptText = t('cookie_consent_accept');
  const declineText = t('cookie_consent_decline');

  // const titleText = 'We use cookies';
  // const descriptionText =
  //   'We use cookies to ensure that our website functions properly, to provide social media features and to analyze web traffic.';
  // const acceptText = 'Accept';
  // const declineText = 'Decline';

  return (
    <CookieConsent
      containerClasses="cookie-banner__container"
      contentClasses="cookie-banner__content"
      buttonClasses="cookie-banner__button-accept"
      buttonWrapperClasses="cookie-banner__button-wrapper"
      declineButtonClasses="cookie-banner__button-decline"
      enableDeclineButton
      declineButtonText={declineText}
      buttonText={acceptText}
      flipButtons
    >
      <Text className="cookie-banner__title" type="p" weight="bold">
        {titleText}
      </Text>
      <Text className="cookie-banner__description" type="p">
        {descriptionText}
      </Text>
    </CookieConsent>
  );
};

export default React.memo(CookieBanner);
